import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function UserArrowRight({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M17.0001 20C17.0001 17.5 15.0001 15.6 12.6001 15.6H7.5001C5.0001 15.6 3.1001 17.6 3.1001 20M17.0001 12H22.0001M22.0001 12L20.0001 14M22.0001 12L20.0001 10M7.0001 5.40001C5.4001 7.00001 5.4001 9.70001 7.0001 11.3C8.6001 12.9 11.3001 12.9 12.9001 11.3C14.5001 9.70001 14.5001 7.00001 12.9001 5.40001C11.3001 3.80001 8.7001 3.80001 7.0001 5.40001Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default UserArrowRight;